import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import OrdersList from './saved-orders-list'
import {getSavedOrders} from '../../actions/orders'

class SavedOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {pageNumber: 1};
  }

  componentWillMount() {
    this.props.dispatch(getSavedOrders());
  }

  handlePageChange = (page, size) => {
    this.props.dispatch(getSavedOrders(page));
    this.setState({pageNumber:  page});
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            {this.props.fetched &&
             <OrdersList
               orders={this.props.orders}
               fetching={this.props.fetching}
               fetched={this.props.fetched}
               pagination={this.props.pagination}
               onPageChange={this.handlePageChange}
               currentPage={this.state.pageNumber}
              />}
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders:   state.orders.savedList,
    pagination:   state.orders.savedListPaging,
    fetching: state.orders.saved_fetching,
    fetched:  state.orders.saved_fetched
  };
};

export default connect(mapStateToProps)(SavedOrders);


// WEBPACK FOOTER //
// ./src/components/my-orders/saved-orders.jsx